import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IAnasayfacopy_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IAnasayfacopy_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GetUserWithGroupDetails: any[];
  GetUserWithGroupDetails_dummy: any[];
  CountForDashboard: any[];
  CountForDashboard_dummy: any[];
  GetAllCustomers: any[];
  GetAllCustomers_dummy: any[];
  GetOrdersCompletedAndActiveByCustomer: any[];
  GetOrdersCompletedAndActiveByCustomer_dummy: any[];
  GetOrdersSumCompletedByCustomer: any[];
  GetOrdersSumCompletedByCustomer_dummy: any[];
  GetStationsAdmin: any[];
  GetStationsAdmin_dummy: any[];
  SetLanguage: string;
  SetLanguage_dummy: string;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  GetOrdersCompletedByStations: any[];
  GetOrdersCompletedByStations_dummy: any[];
  ChangeVisibilityOf: string;
  ChangeVisibilityOf_dummy: string;
  IfThenElse: boolean;
  IfThenElse_dummy: boolean;
  GetCustomerStationWithCustId: any[];
  GetCustomerStationWithCustId_dummy: any[];
  ExportExcel: any;
  ExportExcel_dummy: any;
  StationReviewForHomePage: any[];
  StationReviewForHomePage_dummy: any[];
  GetOrdersLastTen: any[];
  GetOrdersLastTen_dummy: any[];
  STDGetAllProducts: any[];
  STDGetAllProducts_dummy: any[];
  STDGetInfoBasedOnProducts: any[];
  STDGetInfoBasedOnProducts_dummy: any[];
  STDGetInfoBasedOnProductsByCustomer: any[];
  STDGetInfoBasedOnProductsByCustomer_dummy: any[];
  STDGetInfoBasedOnProductsByStation: any[];
  STDGetInfoBasedOnProductsByStation_dummy: any[];
  isComp344445Visible: "visible" | "hidden";
  isComp983413Visible: "visible" | "hidden";
  isComp491990Visible: "visible" | "hidden";
  isComp211941Visible: "visible" | "hidden";
  isComp390142Visible: "visible" | "hidden";
  isComp976313Visible: "visible" | "hidden";
  isComp198696Visible: "visible" | "hidden";
  isComp719750Visible: "visible" | "hidden";
  isComp754036Visible: "visible" | "hidden";
  isComp421259Visible: "visible" | "hidden";
  isComp60461Visible: "visible" | "hidden";
  isComp603599Visible: "visible" | "hidden";
  isComp828771Visible: "visible" | "hidden";
  isComp883639Visible: "visible" | "hidden";
  isComp263906Visible: "visible" | "hidden";
  isComp945749Visible: "visible" | "hidden";

  isMasterPageInitLoaded?: boolean;
  isMasterPageRecurringLoaded?: boolean;
  shouldTriggerPageInit?: boolean;
}

export class Anasayfacopy_ScreenBase extends React.PureComponent<
  IAnasayfacopy_ScreenProps,
  any
> {
  anasayfacopy_161039_value_kuikaSelectBoxRef: React.RefObject<any>;
  anasayfacopy_547143_value_kuikaSelectBoxRef: React.RefObject<any>;
  anasayfacopy_390142_value_kuikaSelectBoxRef: React.RefObject<any>;
  anasayfacopy_682792_value_kuikaPaginationRef: React.RefObject<any>;
  anasayfacopy_792267_value_kuikaTableRef: React.RefObject<any>;
  anasayfacopy_240511_value_kuikaTableRef: React.RefObject<any>;
  anasayfacopy_654375_value_kuikaAutoCompleteRef: React.RefObject<any>;
  ml = [
    {
      Id: "25c1b361-4262-e567-aef0-4b8ceff8261c",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "ea2af393-7864-0865-c06a-2b07d10d3ec8",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "1b0a4ff3-6fea-4080-a965-1e66c99d7015",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 621112, PropertyName: "value", Value: "Müşteriler" },
        { Id: 795092, PropertyName: "value", Value: "Detay Gör" },
        { Id: 215176, PropertyName: "value", Value: "İstasyon" },
        { Id: 248139, PropertyName: "value", Value: "Detay Gör" },
        { Id: 217996, PropertyName: "value", Value: "KLT Miktarı" },
        { Id: 289291, PropertyName: "value", Value: "Detay Gör" },
        { Id: 63102, PropertyName: "value", Value: "Toplam Kutu Siparişleri" },
        { Id: 504556, PropertyName: "value", Value: "Detay Gör" },
        { Id: 533774, PropertyName: "tab", Value: "Müşteri Özeti" },
        { Id: 161039, PropertyName: "placeholder", Value: "Tüm Müşteriler" },
        { Id: 343816, PropertyName: "value", Value: "Tamamlanan Sipariş" },
        { Id: 754761, PropertyName: "value", Value: "Aktif Sipariş" },
        { Id: 813730, PropertyName: "value", Value: "Aktif KLT Miktarı" },
        { Id: 805221, PropertyName: "value", Value: "İstasyon" },
        { Id: 974593, PropertyName: "tab", Value: "İstasyon Özet - Grafik" },
        {
          Id: 967152,
          PropertyName: "placeholder",
          Value: "Ürün Kodu ile Ara...",
        },
        { Id: 547143, PropertyName: "placeholder", Value: "Tüm Müşteriler" },
        { Id: 390142, PropertyName: "placeholder", Value: "Tüm İstasyonlar" },
        { Id: 100923, PropertyName: "value", Value: "Ürün Çeşidi" },
        { Id: 886595, PropertyName: "value", Value: "Kutu Adedi" },
        { Id: 238551, PropertyName: "label", Value: "Dışa Aktar" },
        { Id: 912164, PropertyName: "value", Value: "Öngörülen Adet" },
        { Id: 228592, PropertyName: "value", Value: "Öngörülen Adet" },
        { Id: 895929, PropertyName: "value", Value: "Tamamlanan Adet" },
        { Id: 442140, PropertyName: "value", Value: "Tamamlanan Adet" },
        { Id: 960444, PropertyName: "tab", Value: "İstasyon Özet - Liste" },
        { Id: 250387, PropertyName: "label", Value: "Dışarı Aktar" },
        { Id: 168994, PropertyName: "title", Value: "Müşteri Adı" },
        {
          Id: 627203,
          PropertyName: "value",
          Value: "[datafield:customername]",
        },
        { Id: 963685, PropertyName: "title", Value: "İstasyon Adı" },
        { Id: 710557, PropertyName: "value", Value: "[datafield:stationname]" },
        { Id: 152218, PropertyName: "title", Value: "STenco Ürün Kodu" },
        { Id: 835531, PropertyName: "value", Value: "[datafield:productcode]" },
        { Id: 296817, PropertyName: "title", Value: "STenco Ürün Adı" },
        { Id: 129987, PropertyName: "value", Value: "[datafield:productname]" },
        { Id: 39999, PropertyName: "title", Value: "Müşteri Ürün Adı" },
        {
          Id: 4880,
          PropertyName: "value",
          Value: "[datafield:customerproductname]",
        },
        { Id: 185363, PropertyName: "title", Value: "Öngörülen Adet" },
        {
          Id: 624376,
          PropertyName: "value",
          Value: "[datafield:ongorulenadet]",
        },
        { Id: 224018, PropertyName: "title", Value: "Tamamlanan Adet" },
        {
          Id: 101507,
          PropertyName: "value",
          Value: "[datafield:tamamlananadet]",
        },
        { Id: 935372, PropertyName: "title", Value: "Tamamlanma Oranı" },
        {
          Id: 709479,
          PropertyName: "value",
          Value: "[datafield:tamamlanmaorani]",
        },
        { Id: 357830, PropertyName: "tab", Value: "Son Siparişler" },
        { Id: 828771, PropertyName: "label", Value: "Tümünü Görüntüle" },
        { Id: 974290, PropertyName: "title", Value: "Müşteri Malzeme No" },
        {
          Id: 899653,
          PropertyName: "value",
          Value: "[datafield:customerproductcode]",
        },
        { Id: 772136, PropertyName: "title", Value: "STenco Malzeme No" },
        { Id: 165715, PropertyName: "value", Value: "[datafield:productcode]" },
        { Id: 613322, PropertyName: "title", Value: "STenco Ürün Tanımı" },
        { Id: 452830, PropertyName: "value", Value: "[datafield:productname]" },
        { Id: 211730, PropertyName: "title", Value: "Kanban Kutu İçi Adet" },
        {
          Id: 717129,
          PropertyName: "value",
          Value: "[datafield:expectedquantity]",
        },
        { Id: 162884, PropertyName: "title", Value: "Bulunan İstasyon" },
        { Id: 189125, PropertyName: "value", Value: "[datafield:stationname]" },
        { Id: 829925, PropertyName: "title", Value: "Oluşturma Tarihi" },
        { Id: 574909, PropertyName: "value", Value: "[datafield:createdate]" },
        { Id: 810838, PropertyName: "title", Value: "Sipariş No" },
        { Id: 625528, PropertyName: "value", Value: "[datafield:saporderid]" },
        { Id: 551535, PropertyName: "title", Value: "Sipariş Durumu" },
        { Id: 883639, PropertyName: "value", Value: "Bekliyor" },
        { Id: 263906, PropertyName: "value", Value: "Kısmi Tamamlandı" },
        { Id: 945749, PropertyName: "value", Value: "Tamamlandı" },
        { Id: 986150, PropertyName: "tab", Value: "Ürün Özeti" },
        { Id: 654375, PropertyName: "placeholder", Value: "Ürünler" },
        { Id: 532879, PropertyName: "label", Value: "Müşteri Bazlı" },
        { Id: 578257, PropertyName: "label", Value: "İstasyon Bazlı" },
        { Id: 867801, PropertyName: "label", Value: "Genel Görünüm" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);
    this.anasayfacopy_161039_value_kuikaSelectBoxRef = React.createRef();
    this.anasayfacopy_967152_value_kuikaTextInputRef = React.createRef();
    this.anasayfacopy_547143_value_kuikaSelectBoxRef = React.createRef();
    this.anasayfacopy_390142_value_kuikaSelectBoxRef = React.createRef();
    this.anasayfacopy_682792_value_kuikaPaginationRef = React.createRef();
    this.anasayfacopy_792267_value_kuikaTableRef = React.createRef();
    this.anasayfacopy_240511_value_kuikaTableRef = React.createRef();
    this.anasayfacopy_654375_value_kuikaAutoCompleteRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GetUserWithGroupDetails: [],
      CountForDashboard: [],
      GetAllCustomers: [],
      GetOrdersCompletedAndActiveByCustomer: [],
      GetOrdersSumCompletedByCustomer: [],
      GetStationsAdmin: [],
      SetLanguage: "",
      NAVIGATE: "",
      GetOrdersCompletedByStations: [],
      IfThenElse: false,
      ChangeVisibilityOf: "",
      GetCustomerStationWithCustId: [],
      ExportExcel: "",
      StationReviewForHomePage: [],
      GetOrdersLastTen: [],
      STDGetAllProducts: [],
      STDGetInfoBasedOnProducts: [],
      STDGetInfoBasedOnProductsByCustomer: [],
      STDGetInfoBasedOnProductsByStation: [],
      isComp344445Visible: "visible",
      isComp983413Visible: "hidden",
      isComp491990Visible: "hidden",
      isComp211941Visible: "visible",
      isComp390142Visible: "visible",
      isComp976313Visible: "visible",
      isComp198696Visible: "hidden",
      isComp719750Visible: "hidden",
      isComp754036Visible: "hidden",
      isComp421259Visible: "hidden",
      isComp60461Visible: "hidden",
      isComp603599Visible: "hidden",
      isComp828771Visible: "hidden",
      isComp883639Visible: "hidden",
      isComp263906Visible: "hidden",
      isComp945749Visible: "hidden",

      isMasterPageInitLoaded: false,
      isMasterPageRecurringLoaded: false,
      shouldTriggerPageInit: false,
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight(
        "anasayfacopy",
        "newlayout_screen"
      );
      return;
    }

    ReactSystemFunctions.validateToken();
    if (false) {
      await this.AnasayfacopyPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight(
      "anasayfacopy",
      "newlayout_screen"
    );

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight(
      "anasayfacopy",
      "newlayout_screen"
    );
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.AnasayfacopyPageInit();
    }

    if (
      prevState.isMasterPageInitLoaded !== this.state.isMasterPageInitLoaded &&
      this.state.isMasterPageInitLoaded === true
    ) {
      await this.AnasayfacopyPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  checkTabErrors = () => {
    document.querySelectorAll(".rc-tabs-tab").forEach((tab) => {
      (tab as HTMLElement).style.color = "";
    });

    const tabPanes = document.querySelectorAll(".rc-tabs-tabpane");
    const tabs = document.querySelectorAll(".rc-tabs-tab");

    tabPanes.forEach((tabPane, index) => {
      const uniquePaneId = `rc-tabs-tabpane-${index}`;
      if (!tabPane.hasAttribute("id")) {
        tabPane.setAttribute("id", uniquePaneId);
      }

      const uniqueTabId = `rc-tabs-tab-${index}`;
      if (tabs[index]) {
        if (!tabs[index].hasAttribute("id")) {
          tabs[index].setAttribute("id", uniqueTabId);
        }
        tabs[index].setAttribute("aria-controls", uniquePaneId);
      }
    });

    const errorElements = document.querySelectorAll(
      ".rc-tabs .ant-form-item-explain-error"
    );

    const tabsWithErrors = new Set<string>();

    errorElements.forEach((errorElement) => {
      const tabPane = errorElement.closest(".rc-tabs-tabpane");
      if (tabPane && tabPane.id) {
        tabsWithErrors.add(tabPane.id);
      }
    });

    tabsWithErrors.forEach((tabPaneId) => {
      const tab = document.querySelector(
        `.rc-tabs-tab[aria-controls="${tabPaneId}"]`
      );
      if (tab) {
        (tab as HTMLElement).style.color = "red";
      }
    });
  };

  setMasterPageInitLoaded = (value: boolean) => {
    this.setState({ isMasterPageInitLoaded: value });
  };

  setMasterPageRecurringLoaded = (value: boolean) => {
    this.setState({ isMasterPageRecurringLoaded: value });
  };
  setShouldTriggerPageInit = (value: boolean) => {
    this.setState({ shouldTriggerPageInit: value });
  };

  AnasayfacopyPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      UserName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
      CustomerId_3: ReactSystemFunctions.convertToTypeByName(null, "Guid"),
      CustomerId_4: ReactSystemFunctions.convertToTypeByName(null, "Guid"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Anasayfacopy/AnasayfacopyPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetUserWithGroupDetails = result?.data.getUserWithGroupDetails;
    stateVars.isComp754036Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].customerView
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].customerView
            : null
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp421259Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].stationsView
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].stationsView
            : null
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp60461Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].boxView
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].boxView
            : null
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp603599Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].orderView
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].orderView
            : null
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp828771Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].orderView
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].orderView
            : null
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.CountForDashboard = result?.data.countForDashboard;
    formVars.anasayfacopy_962971_value = ReactSystemFunctions.toString(
      this,
      stateVars.CountForDashboard !== undefined
        ? stateVars.CountForDashboard?.length > 0
          ? stateVars.CountForDashboard[0].customerCount
          : null
        : this.state.CountForDashboard?.length > 0
        ? this.state.CountForDashboard[0].customerCount
        : null
    );
    formVars.anasayfacopy_26029_value = ReactSystemFunctions.toString(
      this,
      stateVars.CountForDashboard !== undefined
        ? stateVars.CountForDashboard?.length > 0
          ? stateVars.CountForDashboard[0].stationCount
          : null
        : this.state.CountForDashboard?.length > 0
        ? this.state.CountForDashboard[0].stationCount
        : null
    );
    formVars.anasayfacopy_624792_value = ReactSystemFunctions.toString(
      this,
      stateVars.CountForDashboard !== undefined
        ? stateVars.CountForDashboard?.length > 0
          ? stateVars.CountForDashboard[0].boxCount
          : null
        : this.state.CountForDashboard?.length > 0
        ? this.state.CountForDashboard[0].boxCount
        : null
    );
    formVars.anasayfacopy_994039_value = ReactSystemFunctions.toString(
      this,
      stateVars.CountForDashboard !== undefined
        ? stateVars.CountForDashboard?.length > 0
          ? stateVars.CountForDashboard[0].orderCount
          : null
        : this.state.CountForDashboard?.length > 0
        ? this.state.CountForDashboard[0].orderCount
        : null
    );
    stateVars.GetAllCustomers = result?.data.getAllCustomers;

    formVars.anasayfacopy_161039_options = stateVars.GetAllCustomers;

    formVars.anasayfacopy_547143_options = stateVars.GetAllCustomers;
    stateVars.GetOrdersCompletedAndActiveByCustomer =
      result?.data.getOrdersCompletedAndActiveByCustomer;
    formVars.anasayfacopy_105356_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetOrdersCompletedAndActiveByCustomer !== undefined
        ? stateVars.GetOrdersCompletedAndActiveByCustomer?.length > 0
          ? stateVars.GetOrdersCompletedAndActiveByCustomer[0].completedOrders
          : null
        : this.state.GetOrdersCompletedAndActiveByCustomer?.length > 0
        ? this.state.GetOrdersCompletedAndActiveByCustomer[0].completedOrders
        : null
    );
    formVars.anasayfacopy_404414_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetOrdersCompletedAndActiveByCustomer !== undefined
        ? stateVars.GetOrdersCompletedAndActiveByCustomer?.length > 0
          ? stateVars.GetOrdersCompletedAndActiveByCustomer[0].activeOrders
          : null
        : this.state.GetOrdersCompletedAndActiveByCustomer?.length > 0
        ? this.state.GetOrdersCompletedAndActiveByCustomer[0].activeOrders
        : null
    );
    formVars.anasayfacopy_849967_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetOrdersCompletedAndActiveByCustomer !== undefined
        ? stateVars.GetOrdersCompletedAndActiveByCustomer?.length > 0
          ? stateVars.GetOrdersCompletedAndActiveByCustomer[0].uniqueBoxes
          : null
        : this.state.GetOrdersCompletedAndActiveByCustomer?.length > 0
        ? this.state.GetOrdersCompletedAndActiveByCustomer[0].uniqueBoxes
        : null
    );
    formVars.anasayfacopy_309648_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetOrdersCompletedAndActiveByCustomer !== undefined
        ? stateVars.GetOrdersCompletedAndActiveByCustomer?.length > 0
          ? stateVars.GetOrdersCompletedAndActiveByCustomer[0].totalStations
          : null
        : this.state.GetOrdersCompletedAndActiveByCustomer?.length > 0
        ? this.state.GetOrdersCompletedAndActiveByCustomer[0].totalStations
        : null
    );
    stateVars.GetOrdersSumCompletedByCustomer =
      result?.data.getOrdersSumCompletedByCustomer;

    stateVars.GetStationsAdmin = result?.data.getStationsAdmin;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.AnasayfacopyPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AnasayfacopyPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetLanguage = await ReactSystemFunctions.setLanguage(
      this,
      ReactSystemFunctions.convertToTypeByName("tr_TR", "string")
    );
    formVars.anasayfacopy_962971_value = ReactSystemFunctions.toString(
      this,
      stateVars.CountForDashboard !== undefined
        ? stateVars.CountForDashboard?.length > 0
          ? stateVars.CountForDashboard[0].customerCount
          : null
        : this.state.CountForDashboard?.length > 0
        ? this.state.CountForDashboard[0].customerCount
        : null
    );

    stateVars.isComp754036Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].customerView
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].customerView
            : null
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    formVars.anasayfacopy_26029_value = ReactSystemFunctions.toString(
      this,
      stateVars.CountForDashboard !== undefined
        ? stateVars.CountForDashboard?.length > 0
          ? stateVars.CountForDashboard[0].stationCount
          : null
        : this.state.CountForDashboard?.length > 0
        ? this.state.CountForDashboard[0].stationCount
        : null
    );

    stateVars.isComp421259Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].stationsView
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].stationsView
            : null
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    formVars.anasayfacopy_624792_value = ReactSystemFunctions.toString(
      this,
      stateVars.CountForDashboard !== undefined
        ? stateVars.CountForDashboard?.length > 0
          ? stateVars.CountForDashboard[0].boxCount
          : null
        : this.state.CountForDashboard?.length > 0
        ? this.state.CountForDashboard[0].boxCount
        : null
    );

    stateVars.isComp60461Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].boxView
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].boxView
            : null
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    formVars.anasayfacopy_994039_value = ReactSystemFunctions.toString(
      this,
      stateVars.CountForDashboard !== undefined
        ? stateVars.CountForDashboard?.length > 0
          ? stateVars.CountForDashboard[0].orderCount
          : null
        : this.state.CountForDashboard?.length > 0
        ? this.state.CountForDashboard[0].orderCount
        : null
    );

    stateVars.isComp603599Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].orderView
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].orderView
            : null
        ),
        true
      ) === true
        ? "visible"
        : "hidden";

    stateVars.dataSource_161039 =
      stateVars.GetAllCustomers ?? this.state.GetAllCustomers;
    stateVars.dataSource_161039 =
      stateVars.GetAllCustomers ?? this.state.GetAllCustomers;
    formVars.anasayfacopy_105356_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetOrdersCompletedAndActiveByCustomer !== undefined
        ? stateVars.GetOrdersCompletedAndActiveByCustomer?.length > 0
          ? stateVars.GetOrdersCompletedAndActiveByCustomer[0].completedOrders
          : null
        : this.state.GetOrdersCompletedAndActiveByCustomer?.length > 0
        ? this.state.GetOrdersCompletedAndActiveByCustomer[0].completedOrders
        : null
    );

    formVars.anasayfacopy_404414_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetOrdersCompletedAndActiveByCustomer !== undefined
        ? stateVars.GetOrdersCompletedAndActiveByCustomer?.length > 0
          ? stateVars.GetOrdersCompletedAndActiveByCustomer[0].activeOrders
          : null
        : this.state.GetOrdersCompletedAndActiveByCustomer?.length > 0
        ? this.state.GetOrdersCompletedAndActiveByCustomer[0].activeOrders
        : null
    );

    formVars.anasayfacopy_849967_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetOrdersCompletedAndActiveByCustomer !== undefined
        ? stateVars.GetOrdersCompletedAndActiveByCustomer?.length > 0
          ? stateVars.GetOrdersCompletedAndActiveByCustomer[0].uniqueBoxes
          : null
        : this.state.GetOrdersCompletedAndActiveByCustomer?.length > 0
        ? this.state.GetOrdersCompletedAndActiveByCustomer[0].uniqueBoxes
        : null
    );

    formVars.anasayfacopy_309648_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetOrdersCompletedAndActiveByCustomer !== undefined
        ? stateVars.GetOrdersCompletedAndActiveByCustomer?.length > 0
          ? stateVars.GetOrdersCompletedAndActiveByCustomer[0].totalStations
          : null
        : this.state.GetOrdersCompletedAndActiveByCustomer?.length > 0
        ? this.state.GetOrdersCompletedAndActiveByCustomer[0].totalStations
        : null
    );

    stateVars.dataSource_68025 =
      stateVars.GetOrdersSumCompletedByCustomer ??
      this.state.GetOrdersSumCompletedByCustomer;

    stateVars.dataSource_547143 =
      stateVars.GetAllCustomers ?? this.state.GetAllCustomers;
    stateVars.dataSource_547143 =
      stateVars.GetAllCustomers ?? this.state.GetAllCustomers;
    stateVars.isComp828771Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].orderView
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].orderView
            : null
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp883639Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "anasayfacopy_240511_value",
          "orderStatus"
        ),
        "2"
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp263906Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "anasayfacopy_240511_value",
          "orderStatus"
        ),
        "4"
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp945749Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "anasayfacopy_240511_value",
          "orderStatus"
        ),
        "3"
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  AnasayfacopyComponent_713106_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "Anasayfacopy",
      "Customer_List",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AnasayfacopyComponent_703807_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "Anasayfacopy",
      "Station_List",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AnasayfacopyComponent_937949_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "Anasayfacopy",
      "STDBoxes_List",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AnasayfacopyComponent_212295_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "Anasayfacopy",
      "Orders_List",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AnasayfacopyComponent_161039_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CustomerId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "anasayfacopy_161039_value",
            "value",
            "GetAllCustomers",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      CustomerId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "anasayfacopy_161039_value",
            "value",
            "GetAllCustomers",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Anasayfacopy/AnasayfacopyComponent_161039_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetOrdersCompletedAndActiveByCustomer =
      result?.data.getOrdersCompletedAndActiveByCustomer;
    formVars.anasayfacopy_105356_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetOrdersCompletedAndActiveByCustomer !== undefined
        ? stateVars.GetOrdersCompletedAndActiveByCustomer?.length > 0
          ? stateVars.GetOrdersCompletedAndActiveByCustomer[0].completedOrders
          : null
        : this.state.GetOrdersCompletedAndActiveByCustomer?.length > 0
        ? this.state.GetOrdersCompletedAndActiveByCustomer[0].completedOrders
        : null
    );
    formVars.anasayfacopy_404414_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetOrdersCompletedAndActiveByCustomer !== undefined
        ? stateVars.GetOrdersCompletedAndActiveByCustomer?.length > 0
          ? stateVars.GetOrdersCompletedAndActiveByCustomer[0].activeOrders
          : null
        : this.state.GetOrdersCompletedAndActiveByCustomer?.length > 0
        ? this.state.GetOrdersCompletedAndActiveByCustomer[0].activeOrders
        : null
    );
    formVars.anasayfacopy_849967_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetOrdersCompletedAndActiveByCustomer !== undefined
        ? stateVars.GetOrdersCompletedAndActiveByCustomer?.length > 0
          ? stateVars.GetOrdersCompletedAndActiveByCustomer[0].uniqueBoxes
          : null
        : this.state.GetOrdersCompletedAndActiveByCustomer?.length > 0
        ? this.state.GetOrdersCompletedAndActiveByCustomer[0].uniqueBoxes
        : null
    );
    formVars.anasayfacopy_309648_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetOrdersCompletedAndActiveByCustomer !== undefined
        ? stateVars.GetOrdersCompletedAndActiveByCustomer?.length > 0
          ? stateVars.GetOrdersCompletedAndActiveByCustomer[0].totalStations
          : null
        : this.state.GetOrdersCompletedAndActiveByCustomer?.length > 0
        ? this.state.GetOrdersCompletedAndActiveByCustomer[0].totalStations
        : null
    );
    stateVars.GetOrdersSumCompletedByCustomer =
      result?.data.getOrdersSumCompletedByCustomer;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.AnasayfacopyComponent_161039_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AnasayfacopyComponent_161039_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.anasayfacopy_105356_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetOrdersCompletedAndActiveByCustomer !== undefined
        ? stateVars.GetOrdersCompletedAndActiveByCustomer?.length > 0
          ? stateVars.GetOrdersCompletedAndActiveByCustomer[0].completedOrders
          : null
        : this.state.GetOrdersCompletedAndActiveByCustomer?.length > 0
        ? this.state.GetOrdersCompletedAndActiveByCustomer[0].completedOrders
        : null
    );

    formVars.anasayfacopy_404414_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetOrdersCompletedAndActiveByCustomer !== undefined
        ? stateVars.GetOrdersCompletedAndActiveByCustomer?.length > 0
          ? stateVars.GetOrdersCompletedAndActiveByCustomer[0].activeOrders
          : null
        : this.state.GetOrdersCompletedAndActiveByCustomer?.length > 0
        ? this.state.GetOrdersCompletedAndActiveByCustomer[0].activeOrders
        : null
    );

    formVars.anasayfacopy_849967_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetOrdersCompletedAndActiveByCustomer !== undefined
        ? stateVars.GetOrdersCompletedAndActiveByCustomer?.length > 0
          ? stateVars.GetOrdersCompletedAndActiveByCustomer[0].uniqueBoxes
          : null
        : this.state.GetOrdersCompletedAndActiveByCustomer?.length > 0
        ? this.state.GetOrdersCompletedAndActiveByCustomer[0].uniqueBoxes
        : null
    );

    formVars.anasayfacopy_309648_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetOrdersCompletedAndActiveByCustomer !== undefined
        ? stateVars.GetOrdersCompletedAndActiveByCustomer?.length > 0
          ? stateVars.GetOrdersCompletedAndActiveByCustomer[0].totalStations
          : null
        : this.state.GetOrdersCompletedAndActiveByCustomer?.length > 0
        ? this.state.GetOrdersCompletedAndActiveByCustomer[0].totalStations
        : null
    );

    stateVars.dataSource_68025 =
      stateVars.GetOrdersSumCompletedByCustomer ??
      this.state.GetOrdersSumCompletedByCustomer;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AnasayfacopyComponent_974593_onActive = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CustomerIdTest_0: ReactSystemFunctions.convertToTypeByName(null, "Guid"),
      StationIdTest_0: ReactSystemFunctions.convertToTypeByName(null, "Guid"),
      SearchTermParam_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "anasayfacopy_967152_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      CurrentPage_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "anasayfacopy_682792_value",
            "current",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      PageSize_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "anasayfacopy_682792_value",
            "pageSize",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      OngoruBool_0: ReactSystemFunctions.convertToTypeByName(true, "boolean"),
      TamamBool_0: ReactSystemFunctions.convertToTypeByName(true, "boolean"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Anasayfacopy/AnasayfacopyComponent_974593_onActive",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetOrdersCompletedByStations =
      result?.data.getOrdersCompletedByStations;

    formVars.anasayfacopy_331475_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetOrdersCompletedByStations !== undefined
        ? stateVars.GetOrdersCompletedByStations?.length > 0
          ? stateVars.GetOrdersCompletedByStations[0].uniqueProducts
          : null
        : this.state.GetOrdersCompletedByStations?.length > 0
        ? this.state.GetOrdersCompletedByStations[0].uniqueProducts
        : null
    );
    formVars.anasayfacopy_265168_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetOrdersCompletedByStations !== undefined
        ? stateVars.GetOrdersCompletedByStations?.length > 0
          ? stateVars.GetOrdersCompletedByStations[0].totalBoxes
          : null
        : this.state.GetOrdersCompletedByStations?.length > 0
        ? this.state.GetOrdersCompletedByStations[0].totalBoxes
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.AnasayfacopyComponent_974593_onActive1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AnasayfacopyComponent_974593_onActive1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.anasayfacopy_331475_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetOrdersCompletedByStations !== undefined
        ? stateVars.GetOrdersCompletedByStations?.length > 0
          ? stateVars.GetOrdersCompletedByStations[0].uniqueProducts
          : null
        : this.state.GetOrdersCompletedByStations?.length > 0
        ? this.state.GetOrdersCompletedByStations[0].uniqueProducts
        : null
    );

    formVars.anasayfacopy_265168_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetOrdersCompletedByStations !== undefined
        ? stateVars.GetOrdersCompletedByStations?.length > 0
          ? stateVars.GetOrdersCompletedByStations[0].totalBoxes
          : null
        : this.state.GetOrdersCompletedByStations?.length > 0
        ? this.state.GetOrdersCompletedByStations[0].totalBoxes
        : null
    );

    stateVars.dataSource_984205 =
      stateVars.GetOrdersCompletedByStations ??
      this.state.GetOrdersCompletedByStations;
    formVars.anasayfacopy_682792_total = ReactSystemFunctions.value(
      this,
      stateVars.GetOrdersCompletedByStations !== undefined
        ? stateVars.GetOrdersCompletedByStations?.length > 0
          ? stateVars.GetOrdersCompletedByStations[0].totalCount
          : null
        : this.state.GetOrdersCompletedByStations?.length > 0
        ? this.state.GetOrdersCompletedByStations[0].totalCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AnasayfacopyComponent_967152_onPressEnter = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CustomerIdTest_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "anasayfacopy_547143_value",
            "value",
            "GetAllCustomers",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      StationIdTest_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "anasayfacopy_390142_value",
            "value",
            "GetCustomerStationWithCustId",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      SearchTermParam_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "anasayfacopy_967152_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      CurrentPage_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "anasayfacopy_682792_value",
            "current",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      PageSize_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "anasayfacopy_682792_value",
            "pageSize",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      OngoruBool_0: ReactSystemFunctions.convertToTypeByName(true, "boolean"),
      TamamBool_0: ReactSystemFunctions.convertToTypeByName(true, "boolean"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Anasayfacopy/AnasayfacopyComponent_967152_onPressEnter",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetOrdersCompletedByStations =
      result?.data.getOrdersCompletedByStations;

    formVars.anasayfacopy_331475_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetOrdersCompletedByStations !== undefined
        ? stateVars.GetOrdersCompletedByStations?.length > 0
          ? stateVars.GetOrdersCompletedByStations[0].uniqueProducts
          : null
        : this.state.GetOrdersCompletedByStations?.length > 0
        ? this.state.GetOrdersCompletedByStations[0].uniqueProducts
        : null
    );
    formVars.anasayfacopy_265168_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetOrdersCompletedByStations !== undefined
        ? stateVars.GetOrdersCompletedByStations?.length > 0
          ? stateVars.GetOrdersCompletedByStations[0].totalBoxes
          : null
        : this.state.GetOrdersCompletedByStations?.length > 0
        ? this.state.GetOrdersCompletedByStations[0].totalBoxes
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.AnasayfacopyComponent_967152_onPressEnter1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AnasayfacopyComponent_967152_onPressEnter_if1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp344445Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp983413Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp491990Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp211941Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  AnasayfacopyComponent_967152_onPressEnter1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (ReactSystemFunctions.isEqualTo(true, true)) {
      isErrorOccurred =
        await this.AnasayfacopyComponent_967152_onPressEnter_if1();
      if (isErrorOccurred) return true;
    } else {
    }

    formVars.anasayfacopy_331475_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetOrdersCompletedByStations !== undefined
        ? stateVars.GetOrdersCompletedByStations?.length > 0
          ? stateVars.GetOrdersCompletedByStations[0].uniqueProducts
          : null
        : this.state.GetOrdersCompletedByStations?.length > 0
        ? this.state.GetOrdersCompletedByStations[0].uniqueProducts
        : null
    );

    formVars.anasayfacopy_265168_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetOrdersCompletedByStations !== undefined
        ? stateVars.GetOrdersCompletedByStations?.length > 0
          ? stateVars.GetOrdersCompletedByStations[0].totalBoxes
          : null
        : this.state.GetOrdersCompletedByStations?.length > 0
        ? this.state.GetOrdersCompletedByStations[0].totalBoxes
        : null
    );

    stateVars.dataSource_984205 =
      stateVars.GetOrdersCompletedByStations ??
      this.state.GetOrdersCompletedByStations;
    formVars.anasayfacopy_682792_total = ReactSystemFunctions.value(
      this,
      stateVars.GetOrdersCompletedByStations !== undefined
        ? stateVars.GetOrdersCompletedByStations?.length > 0
          ? stateVars.GetOrdersCompletedByStations[0].totalCount
          : null
        : this.state.GetOrdersCompletedByStations?.length > 0
        ? this.state.GetOrdersCompletedByStations[0].totalCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AnasayfacopyComponent_744487_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CustomerIdTest_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "anasayfacopy_547143_value",
            "value",
            "GetAllCustomers",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      StationIdTest_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "anasayfacopy_390142_value",
            "value",
            "GetCustomerStationWithCustId",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      SearchTermParam_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "anasayfacopy_967152_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      CurrentPage_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "anasayfacopy_682792_value",
            "current",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      PageSize_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "anasayfacopy_682792_value",
            "pageSize",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      OngoruBool_0: ReactSystemFunctions.convertToTypeByName(true, "boolean"),
      TamamBool_0: ReactSystemFunctions.convertToTypeByName(true, "boolean"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Anasayfacopy/AnasayfacopyComponent_744487_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetOrdersCompletedByStations =
      result?.data.getOrdersCompletedByStations;

    formVars.anasayfacopy_331475_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetOrdersCompletedByStations !== undefined
        ? stateVars.GetOrdersCompletedByStations?.length > 0
          ? stateVars.GetOrdersCompletedByStations[0].uniqueProducts
          : null
        : this.state.GetOrdersCompletedByStations?.length > 0
        ? this.state.GetOrdersCompletedByStations[0].uniqueProducts
        : null
    );
    formVars.anasayfacopy_265168_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetOrdersCompletedByStations !== undefined
        ? stateVars.GetOrdersCompletedByStations?.length > 0
          ? stateVars.GetOrdersCompletedByStations[0].totalBoxes
          : null
        : this.state.GetOrdersCompletedByStations?.length > 0
        ? this.state.GetOrdersCompletedByStations[0].totalBoxes
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.AnasayfacopyComponent_744487_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AnasayfacopyComponent_744487_onClick_if1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp344445Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp983413Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp491990Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp211941Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  AnasayfacopyComponent_744487_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (ReactSystemFunctions.isEqualTo(true, true)) {
      isErrorOccurred = await this.AnasayfacopyComponent_744487_onClick_if1();
      if (isErrorOccurred) return true;
    } else {
    }

    formVars.anasayfacopy_331475_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetOrdersCompletedByStations !== undefined
        ? stateVars.GetOrdersCompletedByStations?.length > 0
          ? stateVars.GetOrdersCompletedByStations[0].uniqueProducts
          : null
        : this.state.GetOrdersCompletedByStations?.length > 0
        ? this.state.GetOrdersCompletedByStations[0].uniqueProducts
        : null
    );

    formVars.anasayfacopy_265168_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetOrdersCompletedByStations !== undefined
        ? stateVars.GetOrdersCompletedByStations?.length > 0
          ? stateVars.GetOrdersCompletedByStations[0].totalBoxes
          : null
        : this.state.GetOrdersCompletedByStations?.length > 0
        ? this.state.GetOrdersCompletedByStations[0].totalBoxes
        : null
    );

    stateVars.dataSource_984205 =
      stateVars.GetOrdersCompletedByStations ??
      this.state.GetOrdersCompletedByStations;
    formVars.anasayfacopy_682792_total = ReactSystemFunctions.value(
      this,
      stateVars.GetOrdersCompletedByStations !== undefined
        ? stateVars.GetOrdersCompletedByStations?.length > 0
          ? stateVars.GetOrdersCompletedByStations[0].totalCount
          : null
        : this.state.GetOrdersCompletedByStations?.length > 0
        ? this.state.GetOrdersCompletedByStations[0].totalCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AnasayfacopyComponent_547143_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp390142Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.AnasayfacopyComponent_547143_onChange1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  AnasayfacopyComponent_547143_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CustomerId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "anasayfacopy_547143_value",
            "value",
            "GetAllCustomers",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      CustomerIdTest_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "anasayfacopy_547143_value",
            "value",
            "GetAllCustomers",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      StationIdTest_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "anasayfacopy_390142_value",
            "value",
            "GetCustomerStationWithCustId",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      SearchTermParam_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "anasayfacopy_967152_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      CurrentPage_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "anasayfacopy_682792_value",
            "current",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      PageSize_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "anasayfacopy_682792_value",
            "pageSize",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      OngoruBool_1: ReactSystemFunctions.convertToTypeByName(true, "boolean"),
      TamamBool_1: ReactSystemFunctions.convertToTypeByName(true, "boolean"),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Anasayfacopy/AnasayfacopyComponent_547143_onChange1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetCustomerStationWithCustId =
      result?.data.getCustomerStationWithCustId;

    formVars.anasayfacopy_390142_options =
      stateVars.GetCustomerStationWithCustId;
    stateVars.GetOrdersCompletedByStations =
      result?.data.getOrdersCompletedByStations;

    formVars.anasayfacopy_331475_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetOrdersCompletedByStations !== undefined
        ? stateVars.GetOrdersCompletedByStations?.length > 0
          ? stateVars.GetOrdersCompletedByStations[0].uniqueProducts
          : null
        : this.state.GetOrdersCompletedByStations?.length > 0
        ? this.state.GetOrdersCompletedByStations[0].uniqueProducts
        : null
    );
    formVars.anasayfacopy_265168_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetOrdersCompletedByStations !== undefined
        ? stateVars.GetOrdersCompletedByStations?.length > 0
          ? stateVars.GetOrdersCompletedByStations[0].totalBoxes
          : null
        : this.state.GetOrdersCompletedByStations?.length > 0
        ? this.state.GetOrdersCompletedByStations[0].totalBoxes
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.AnasayfacopyComponent_547143_onChange2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AnasayfacopyComponent_547143_onChange_if2 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp344445Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp983413Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp491990Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp211941Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  AnasayfacopyComponent_547143_onChange2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (ReactSystemFunctions.isEqualTo(true, true)) {
      isErrorOccurred = await this.AnasayfacopyComponent_547143_onChange_if2();
      if (isErrorOccurred) return true;
    } else {
    }

    stateVars.dataSource_390142 =
      stateVars.GetCustomerStationWithCustId ??
      this.state.GetCustomerStationWithCustId;
    stateVars.dataSource_390142 =
      stateVars.GetCustomerStationWithCustId ??
      this.state.GetCustomerStationWithCustId;
    formVars.anasayfacopy_331475_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetOrdersCompletedByStations !== undefined
        ? stateVars.GetOrdersCompletedByStations?.length > 0
          ? stateVars.GetOrdersCompletedByStations[0].uniqueProducts
          : null
        : this.state.GetOrdersCompletedByStations?.length > 0
        ? this.state.GetOrdersCompletedByStations[0].uniqueProducts
        : null
    );

    formVars.anasayfacopy_265168_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetOrdersCompletedByStations !== undefined
        ? stateVars.GetOrdersCompletedByStations?.length > 0
          ? stateVars.GetOrdersCompletedByStations[0].totalBoxes
          : null
        : this.state.GetOrdersCompletedByStations?.length > 0
        ? this.state.GetOrdersCompletedByStations[0].totalBoxes
        : null
    );

    stateVars.dataSource_984205 =
      stateVars.GetOrdersCompletedByStations ??
      this.state.GetOrdersCompletedByStations;
    formVars.anasayfacopy_682792_total = ReactSystemFunctions.value(
      this,
      stateVars.GetOrdersCompletedByStations !== undefined
        ? stateVars.GetOrdersCompletedByStations?.length > 0
          ? stateVars.GetOrdersCompletedByStations[0].totalCount
          : null
        : this.state.GetOrdersCompletedByStations?.length > 0
        ? this.state.GetOrdersCompletedByStations[0].totalCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AnasayfacopyComponent_390142_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CustomerIdTest_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "anasayfacopy_547143_value",
            "value",
            "GetAllCustomers",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      StationIdTest_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "anasayfacopy_390142_value",
            "value",
            "GetCustomerStationWithCustId",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      SearchTermParam_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "anasayfacopy_967152_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      CurrentPage_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "anasayfacopy_682792_value",
            "current",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      PageSize_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "anasayfacopy_682792_value",
            "pageSize",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      OngoruBool_0: ReactSystemFunctions.convertToTypeByName(true, "boolean"),
      TamamBool_0: ReactSystemFunctions.convertToTypeByName(true, "boolean"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Anasayfacopy/AnasayfacopyComponent_390142_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetOrdersCompletedByStations =
      result?.data.getOrdersCompletedByStations;

    formVars.anasayfacopy_331475_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetOrdersCompletedByStations !== undefined
        ? stateVars.GetOrdersCompletedByStations?.length > 0
          ? stateVars.GetOrdersCompletedByStations[0].uniqueProducts
          : null
        : this.state.GetOrdersCompletedByStations?.length > 0
        ? this.state.GetOrdersCompletedByStations[0].uniqueProducts
        : null
    );
    formVars.anasayfacopy_265168_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetOrdersCompletedByStations !== undefined
        ? stateVars.GetOrdersCompletedByStations?.length > 0
          ? stateVars.GetOrdersCompletedByStations[0].totalBoxes
          : null
        : this.state.GetOrdersCompletedByStations?.length > 0
        ? this.state.GetOrdersCompletedByStations[0].totalBoxes
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.AnasayfacopyComponent_390142_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AnasayfacopyComponent_390142_onChange_if1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp344445Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp983413Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp491990Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp211941Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  AnasayfacopyComponent_390142_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (ReactSystemFunctions.isEqualTo(true, true)) {
      isErrorOccurred = await this.AnasayfacopyComponent_390142_onChange_if1();
      if (isErrorOccurred) return true;
    } else {
    }

    formVars.anasayfacopy_331475_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetOrdersCompletedByStations !== undefined
        ? stateVars.GetOrdersCompletedByStations?.length > 0
          ? stateVars.GetOrdersCompletedByStations[0].uniqueProducts
          : null
        : this.state.GetOrdersCompletedByStations?.length > 0
        ? this.state.GetOrdersCompletedByStations[0].uniqueProducts
        : null
    );

    formVars.anasayfacopy_265168_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetOrdersCompletedByStations !== undefined
        ? stateVars.GetOrdersCompletedByStations?.length > 0
          ? stateVars.GetOrdersCompletedByStations[0].totalBoxes
          : null
        : this.state.GetOrdersCompletedByStations?.length > 0
        ? this.state.GetOrdersCompletedByStations[0].totalBoxes
        : null
    );

    stateVars.dataSource_984205 =
      stateVars.GetOrdersCompletedByStations ??
      this.state.GetOrdersCompletedByStations;
    formVars.anasayfacopy_682792_total = ReactSystemFunctions.value(
      this,
      stateVars.GetOrdersCompletedByStations !== undefined
        ? stateVars.GetOrdersCompletedByStations?.length > 0
          ? stateVars.GetOrdersCompletedByStations[0].totalCount
          : null
        : this.state.GetOrdersCompletedByStations?.length > 0
        ? this.state.GetOrdersCompletedByStations[0].totalCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AnasayfacopyComponent_238551_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      value_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          this.state.GetOrdersCompletedByStations
        ),
        "any"
      ),
      header_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      footer_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      columns_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Anasayfacopy/AnasayfacopyComponent_238551_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.ExportExcel = result?.data.exportExcel;
    ReactSystemFunctions.downloadFile(result?.data?.exportExcel);
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  AnasayfacopyComponent_912164_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CustomerIdTest_0: ReactSystemFunctions.convertToTypeByName(null, "Guid"),
      StationIdTest_0: ReactSystemFunctions.convertToTypeByName(null, "Guid"),
      SearchTermParam_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "anasayfacopy_967152_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      CurrentPage_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "anasayfacopy_682792_value",
            "current",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      PageSize_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "anasayfacopy_682792_value",
            "pageSize",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      OngoruBool_0: ReactSystemFunctions.convertToTypeByName(false, "boolean"),
      TamamBool_0: ReactSystemFunctions.convertToTypeByName(true, "boolean"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Anasayfacopy/AnasayfacopyComponent_912164_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetOrdersCompletedByStations =
      result?.data.getOrdersCompletedByStations;

    formVars.anasayfacopy_331475_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetOrdersCompletedByStations !== undefined
        ? stateVars.GetOrdersCompletedByStations?.length > 0
          ? stateVars.GetOrdersCompletedByStations[0].uniqueProducts
          : null
        : this.state.GetOrdersCompletedByStations?.length > 0
        ? this.state.GetOrdersCompletedByStations[0].uniqueProducts
        : null
    );
    formVars.anasayfacopy_265168_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetOrdersCompletedByStations !== undefined
        ? stateVars.GetOrdersCompletedByStations?.length > 0
          ? stateVars.GetOrdersCompletedByStations[0].totalBoxes
          : null
        : this.state.GetOrdersCompletedByStations?.length > 0
        ? this.state.GetOrdersCompletedByStations[0].totalBoxes
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.AnasayfacopyComponent_912164_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AnasayfacopyComponent_912164_onClick_if1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp344445Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp983413Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp491990Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp211941Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  AnasayfacopyComponent_912164_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (ReactSystemFunctions.isEqualTo(true, true)) {
      isErrorOccurred = await this.AnasayfacopyComponent_912164_onClick_if1();
      if (isErrorOccurred) return true;
    } else {
    }

    formVars.anasayfacopy_331475_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetOrdersCompletedByStations !== undefined
        ? stateVars.GetOrdersCompletedByStations?.length > 0
          ? stateVars.GetOrdersCompletedByStations[0].uniqueProducts
          : null
        : this.state.GetOrdersCompletedByStations?.length > 0
        ? this.state.GetOrdersCompletedByStations[0].uniqueProducts
        : null
    );

    formVars.anasayfacopy_265168_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetOrdersCompletedByStations !== undefined
        ? stateVars.GetOrdersCompletedByStations?.length > 0
          ? stateVars.GetOrdersCompletedByStations[0].totalBoxes
          : null
        : this.state.GetOrdersCompletedByStations?.length > 0
        ? this.state.GetOrdersCompletedByStations[0].totalBoxes
        : null
    );

    stateVars.dataSource_984205 =
      stateVars.GetOrdersCompletedByStations ??
      this.state.GetOrdersCompletedByStations;
    formVars.anasayfacopy_682792_total = ReactSystemFunctions.value(
      this,
      stateVars.GetOrdersCompletedByStations !== undefined
        ? stateVars.GetOrdersCompletedByStations?.length > 0
          ? stateVars.GetOrdersCompletedByStations[0].totalCount
          : null
        : this.state.GetOrdersCompletedByStations?.length > 0
        ? this.state.GetOrdersCompletedByStations[0].totalCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AnasayfacopyComponent_228592_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CustomerIdTest_0: ReactSystemFunctions.convertToTypeByName(null, "Guid"),
      StationIdTest_0: ReactSystemFunctions.convertToTypeByName(null, "Guid"),
      SearchTermParam_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "anasayfacopy_967152_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      CurrentPage_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "anasayfacopy_682792_value",
            "current",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      PageSize_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "anasayfacopy_682792_value",
            "pageSize",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      OngoruBool_0: ReactSystemFunctions.convertToTypeByName(true, "boolean"),
      TamamBool_0: ReactSystemFunctions.convertToTypeByName(false, "boolean"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Anasayfacopy/AnasayfacopyComponent_228592_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetOrdersCompletedByStations =
      result?.data.getOrdersCompletedByStations;

    formVars.anasayfacopy_331475_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetOrdersCompletedByStations !== undefined
        ? stateVars.GetOrdersCompletedByStations?.length > 0
          ? stateVars.GetOrdersCompletedByStations[0].uniqueProducts
          : null
        : this.state.GetOrdersCompletedByStations?.length > 0
        ? this.state.GetOrdersCompletedByStations[0].uniqueProducts
        : null
    );
    formVars.anasayfacopy_265168_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetOrdersCompletedByStations !== undefined
        ? stateVars.GetOrdersCompletedByStations?.length > 0
          ? stateVars.GetOrdersCompletedByStations[0].totalBoxes
          : null
        : this.state.GetOrdersCompletedByStations?.length > 0
        ? this.state.GetOrdersCompletedByStations[0].totalBoxes
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.AnasayfacopyComponent_228592_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AnasayfacopyComponent_228592_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp344445Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp983413Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp491990Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp211941Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );
    formVars.anasayfacopy_331475_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetOrdersCompletedByStations !== undefined
        ? stateVars.GetOrdersCompletedByStations?.length > 0
          ? stateVars.GetOrdersCompletedByStations[0].uniqueProducts
          : null
        : this.state.GetOrdersCompletedByStations?.length > 0
        ? this.state.GetOrdersCompletedByStations[0].uniqueProducts
        : null
    );

    formVars.anasayfacopy_265168_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetOrdersCompletedByStations !== undefined
        ? stateVars.GetOrdersCompletedByStations?.length > 0
          ? stateVars.GetOrdersCompletedByStations[0].totalBoxes
          : null
        : this.state.GetOrdersCompletedByStations?.length > 0
        ? this.state.GetOrdersCompletedByStations[0].totalBoxes
        : null
    );

    stateVars.dataSource_984205 =
      stateVars.GetOrdersCompletedByStations ??
      this.state.GetOrdersCompletedByStations;
    formVars.anasayfacopy_682792_total = ReactSystemFunctions.value(
      this,
      stateVars.GetOrdersCompletedByStations !== undefined
        ? stateVars.GetOrdersCompletedByStations?.length > 0
          ? stateVars.GetOrdersCompletedByStations[0].totalCount
          : null
        : this.state.GetOrdersCompletedByStations?.length > 0
        ? this.state.GetOrdersCompletedByStations[0].totalCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AnasayfacopyComponent_895929_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CustomerIdTest_0: ReactSystemFunctions.convertToTypeByName(null, "Guid"),
      StationIdTest_0: ReactSystemFunctions.convertToTypeByName(null, "Guid"),
      SearchTermParam_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "anasayfacopy_967152_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      CurrentPage_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "anasayfacopy_682792_value",
            "current",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      PageSize_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "anasayfacopy_682792_value",
            "pageSize",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      OngoruBool_0: ReactSystemFunctions.convertToTypeByName(true, "boolean"),
      TamamBool_0: ReactSystemFunctions.convertToTypeByName(false, "boolean"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Anasayfacopy/AnasayfacopyComponent_895929_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetOrdersCompletedByStations =
      result?.data.getOrdersCompletedByStations;

    formVars.anasayfacopy_331475_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetOrdersCompletedByStations !== undefined
        ? stateVars.GetOrdersCompletedByStations?.length > 0
          ? stateVars.GetOrdersCompletedByStations[0].uniqueProducts
          : null
        : this.state.GetOrdersCompletedByStations?.length > 0
        ? this.state.GetOrdersCompletedByStations[0].uniqueProducts
        : null
    );
    formVars.anasayfacopy_265168_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetOrdersCompletedByStations !== undefined
        ? stateVars.GetOrdersCompletedByStations?.length > 0
          ? stateVars.GetOrdersCompletedByStations[0].totalBoxes
          : null
        : this.state.GetOrdersCompletedByStations?.length > 0
        ? this.state.GetOrdersCompletedByStations[0].totalBoxes
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.AnasayfacopyComponent_895929_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AnasayfacopyComponent_895929_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp211941Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp491990Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp344445Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp983413Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );
    formVars.anasayfacopy_331475_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetOrdersCompletedByStations !== undefined
        ? stateVars.GetOrdersCompletedByStations?.length > 0
          ? stateVars.GetOrdersCompletedByStations[0].uniqueProducts
          : null
        : this.state.GetOrdersCompletedByStations?.length > 0
        ? this.state.GetOrdersCompletedByStations[0].uniqueProducts
        : null
    );

    formVars.anasayfacopy_265168_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetOrdersCompletedByStations !== undefined
        ? stateVars.GetOrdersCompletedByStations?.length > 0
          ? stateVars.GetOrdersCompletedByStations[0].totalBoxes
          : null
        : this.state.GetOrdersCompletedByStations?.length > 0
        ? this.state.GetOrdersCompletedByStations[0].totalBoxes
        : null
    );

    stateVars.dataSource_984205 =
      stateVars.GetOrdersCompletedByStations ??
      this.state.GetOrdersCompletedByStations;
    formVars.anasayfacopy_682792_total = ReactSystemFunctions.value(
      this,
      stateVars.GetOrdersCompletedByStations !== undefined
        ? stateVars.GetOrdersCompletedByStations?.length > 0
          ? stateVars.GetOrdersCompletedByStations[0].totalCount
          : null
        : this.state.GetOrdersCompletedByStations?.length > 0
        ? this.state.GetOrdersCompletedByStations[0].totalCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AnasayfacopyComponent_442140_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CustomerIdTest_0: ReactSystemFunctions.convertToTypeByName(null, "Guid"),
      StationIdTest_0: ReactSystemFunctions.convertToTypeByName(null, "Guid"),
      SearchTermParam_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "anasayfacopy_967152_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      CurrentPage_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "anasayfacopy_682792_value",
            "current",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      PageSize_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "anasayfacopy_682792_value",
            "pageSize",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      OngoruBool_0: ReactSystemFunctions.convertToTypeByName(false, "boolean"),
      TamamBool_0: ReactSystemFunctions.convertToTypeByName(true, "boolean"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Anasayfacopy/AnasayfacopyComponent_442140_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetOrdersCompletedByStations =
      result?.data.getOrdersCompletedByStations;

    formVars.anasayfacopy_331475_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetOrdersCompletedByStations !== undefined
        ? stateVars.GetOrdersCompletedByStations?.length > 0
          ? stateVars.GetOrdersCompletedByStations[0].uniqueProducts
          : null
        : this.state.GetOrdersCompletedByStations?.length > 0
        ? this.state.GetOrdersCompletedByStations[0].uniqueProducts
        : null
    );
    formVars.anasayfacopy_265168_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetOrdersCompletedByStations !== undefined
        ? stateVars.GetOrdersCompletedByStations?.length > 0
          ? stateVars.GetOrdersCompletedByStations[0].totalBoxes
          : null
        : this.state.GetOrdersCompletedByStations?.length > 0
        ? this.state.GetOrdersCompletedByStations[0].totalBoxes
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.AnasayfacopyComponent_442140_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AnasayfacopyComponent_442140_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp211941Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp491990Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp344445Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp983413Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );
    formVars.anasayfacopy_331475_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetOrdersCompletedByStations !== undefined
        ? stateVars.GetOrdersCompletedByStations?.length > 0
          ? stateVars.GetOrdersCompletedByStations[0].uniqueProducts
          : null
        : this.state.GetOrdersCompletedByStations?.length > 0
        ? this.state.GetOrdersCompletedByStations[0].uniqueProducts
        : null
    );

    formVars.anasayfacopy_265168_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetOrdersCompletedByStations !== undefined
        ? stateVars.GetOrdersCompletedByStations?.length > 0
          ? stateVars.GetOrdersCompletedByStations[0].totalBoxes
          : null
        : this.state.GetOrdersCompletedByStations?.length > 0
        ? this.state.GetOrdersCompletedByStations[0].totalBoxes
        : null
    );

    stateVars.dataSource_984205 =
      stateVars.GetOrdersCompletedByStations ??
      this.state.GetOrdersCompletedByStations;
    formVars.anasayfacopy_682792_total = ReactSystemFunctions.value(
      this,
      stateVars.GetOrdersCompletedByStations !== undefined
        ? stateVars.GetOrdersCompletedByStations?.length > 0
          ? stateVars.GetOrdersCompletedByStations[0].totalCount
          : null
        : this.state.GetOrdersCompletedByStations?.length > 0
        ? this.state.GetOrdersCompletedByStations[0].totalCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AnasayfacopyComponent_682792_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CustomerIdTest_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "anasayfacopy_547143_value",
            "value",
            "GetAllCustomers",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      StationIdTest_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "anasayfacopy_390142_value",
            "value",
            "GetCustomerStationWithCustId",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      SearchTermParam_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "anasayfacopy_967152_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      CurrentPage_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "anasayfacopy_682792_value",
            "current",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      PageSize_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "anasayfacopy_682792_value",
            "pageSize",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      OngoruBool_0: ReactSystemFunctions.convertToTypeByName(true, "boolean"),
      TamamBool_0: ReactSystemFunctions.convertToTypeByName(true, "boolean"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Anasayfacopy/AnasayfacopyComponent_682792_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetOrdersCompletedByStations =
      result?.data.getOrdersCompletedByStations;

    formVars.anasayfacopy_331475_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetOrdersCompletedByStations !== undefined
        ? stateVars.GetOrdersCompletedByStations?.length > 0
          ? stateVars.GetOrdersCompletedByStations[0].uniqueProducts
          : null
        : this.state.GetOrdersCompletedByStations?.length > 0
        ? this.state.GetOrdersCompletedByStations[0].uniqueProducts
        : null
    );
    formVars.anasayfacopy_265168_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetOrdersCompletedByStations !== undefined
        ? stateVars.GetOrdersCompletedByStations?.length > 0
          ? stateVars.GetOrdersCompletedByStations[0].totalBoxes
          : null
        : this.state.GetOrdersCompletedByStations?.length > 0
        ? this.state.GetOrdersCompletedByStations[0].totalBoxes
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.AnasayfacopyComponent_682792_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AnasayfacopyComponent_682792_onChange_if1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp344445Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp983413Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp491990Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp211941Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  AnasayfacopyComponent_682792_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (ReactSystemFunctions.isEqualTo(true, true)) {
      isErrorOccurred = await this.AnasayfacopyComponent_682792_onChange_if1();
      if (isErrorOccurred) return true;
    } else {
    }

    formVars.anasayfacopy_331475_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetOrdersCompletedByStations !== undefined
        ? stateVars.GetOrdersCompletedByStations?.length > 0
          ? stateVars.GetOrdersCompletedByStations[0].uniqueProducts
          : null
        : this.state.GetOrdersCompletedByStations?.length > 0
        ? this.state.GetOrdersCompletedByStations[0].uniqueProducts
        : null
    );

    formVars.anasayfacopy_265168_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetOrdersCompletedByStations !== undefined
        ? stateVars.GetOrdersCompletedByStations?.length > 0
          ? stateVars.GetOrdersCompletedByStations[0].totalBoxes
          : null
        : this.state.GetOrdersCompletedByStations?.length > 0
        ? this.state.GetOrdersCompletedByStations[0].totalBoxes
        : null
    );

    stateVars.dataSource_984205 =
      stateVars.GetOrdersCompletedByStations ??
      this.state.GetOrdersCompletedByStations;
    formVars.anasayfacopy_682792_total = ReactSystemFunctions.value(
      this,
      stateVars.GetOrdersCompletedByStations !== undefined
        ? stateVars.GetOrdersCompletedByStations?.length > 0
          ? stateVars.GetOrdersCompletedByStations[0].totalCount
          : null
        : this.state.GetOrdersCompletedByStations?.length > 0
        ? this.state.GetOrdersCompletedByStations[0].totalCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AnasayfacopyComponent_960444_onActive = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {};

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Anasayfacopy/AnasayfacopyComponent_960444_onActive",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.StationReviewForHomePage = result?.data.stationReviewForHomePage;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.AnasayfacopyComponent_960444_onActive1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AnasayfacopyComponent_960444_onActive1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_792267 =
      stateVars.StationReviewForHomePage ?? this.state.StationReviewForHomePage;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AnasayfacopyComponent_250387_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      value_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.state.StationReviewForHomePage),
        "any"
      ),
      header_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      footer_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      columns_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Anasayfacopy/AnasayfacopyComponent_250387_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.ExportExcel = result?.data.exportExcel;
    ReactSystemFunctions.downloadFile(result?.data?.exportExcel);
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  AnasayfacopyComponent_357830_onActive = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {};

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Anasayfacopy/AnasayfacopyComponent_357830_onActive",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetOrdersLastTen = result?.data.getOrdersLastTen;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.AnasayfacopyComponent_357830_onActive1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AnasayfacopyComponent_357830_onActive1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_240511 =
      stateVars.GetOrdersLastTen ?? this.state.GetOrdersLastTen;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AnasayfacopyComponent_828771_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "Anasayfacopy",
      "Orders_List",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AnasayfacopyComponent_883639_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "BoxLogs",
      "BoxId",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "anasayfacopy_240511_value", "boxId"),
        "Guid"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "Anasayfacopy",
      "BoxLogs",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "55385",
      null,
      "right",
      "true",
      "500px",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AnasayfacopyComponent_263906_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "BoxLogs",
      "BoxId",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "anasayfacopy_240511_value", "boxId"),
        "Guid"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "Anasayfacopy",
      "BoxLogs",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "981438",
      null,
      "right",
      "true",
      "500px",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AnasayfacopyComponent_945749_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "BoxLogs",
      "BoxId",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "anasayfacopy_240511_value", "boxId"),
        "Guid"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "Anasayfacopy",
      "BoxLogs",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "245443",
      null,
      "right",
      "true",
      "500px",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AnasayfacopyComponent_986150_onActive = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      SelectedProductId_1: ReactSystemFunctions.convertToTypeByName(
        null,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Anasayfacopy/AnasayfacopyComponent_986150_onActive",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.STDGetAllProducts = result?.data.stdGetAllProducts;

    formVars.anasayfacopy_654375_options = stateVars.STDGetAllProducts;
    stateVars.STDGetInfoBasedOnProducts =
      result?.data.stdGetInfoBasedOnProducts;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.AnasayfacopyComponent_986150_onActive1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AnasayfacopyComponent_986150_onActive1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_654375 =
      stateVars.STDGetAllProducts ?? this.state.STDGetAllProducts;
    stateVars.dataSource_654375 =
      stateVars.STDGetAllProducts ?? this.state.STDGetAllProducts;

    stateVars.dataSource_973497 =
      stateVars.STDGetInfoBasedOnProducts ??
      this.state.STDGetInfoBasedOnProducts;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AnasayfacopyComponent_654375_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      SelectedProductId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "anasayfacopy_654375_value",
            "value",
            "STDGetAllProducts",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Anasayfacopy/AnasayfacopyComponent_654375_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.STDGetInfoBasedOnProducts =
      result?.data.stdGetInfoBasedOnProducts;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.AnasayfacopyComponent_654375_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AnasayfacopyComponent_654375_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_973497 =
      stateVars.STDGetInfoBasedOnProducts ??
      this.state.STDGetInfoBasedOnProducts;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AnasayfacopyComponent_532879_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      SelectedProductId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "anasayfacopy_654375_value",
            "value",
            "STDGetAllProducts",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Anasayfacopy/AnasayfacopyComponent_532879_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.STDGetInfoBasedOnProductsByCustomer =
      result?.data.stdGetInfoBasedOnProductsByCustomer;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.AnasayfacopyComponent_532879_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AnasayfacopyComponent_532879_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp976313Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp198696Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp719750Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );

    stateVars.dataSource_802400 =
      stateVars.STDGetInfoBasedOnProductsByCustomer ??
      this.state.STDGetInfoBasedOnProductsByCustomer;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AnasayfacopyComponent_578257_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      SelectedProductId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "anasayfacopy_654375_value",
            "value",
            "STDGetAllProducts",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Anasayfacopy/AnasayfacopyComponent_578257_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.STDGetInfoBasedOnProductsByStation =
      result?.data.stdGetInfoBasedOnProductsByStation;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.AnasayfacopyComponent_578257_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AnasayfacopyComponent_578257_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp976313Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp198696Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp719750Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );

    stateVars.dataSource_93776 =
      stateVars.STDGetInfoBasedOnProductsByStation ??
      this.state.STDGetInfoBasedOnProductsByStation;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AnasayfacopyComponent_867801_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      SelectedProductId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "anasayfacopy_654375_value",
            "value",
            "STDGetAllProducts",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Anasayfacopy/AnasayfacopyComponent_867801_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.STDGetInfoBasedOnProducts =
      result?.data.stdGetInfoBasedOnProducts;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.AnasayfacopyComponent_867801_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AnasayfacopyComponent_867801_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp198696Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp719750Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp976313Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );

    stateVars.dataSource_973497 =
      stateVars.STDGetInfoBasedOnProducts ??
      this.state.STDGetInfoBasedOnProducts;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [, , , , , 55385, 981438, 245443] as number[];
    if (
      isFromMaster ||
      ((window.kuika?.disableSmartExecutePageInit?.["Anasayfacopy"] ?? false) &&
        pageInitCallerNavDiIDs.indexOf(diId) > -1)
    ) {
      await this.AnasayfacopyPageInit();
    } else if (
      window.kuika?.serverRequestCount > 0 &&
      pageInitCallerNavDiIDs.indexOf(diId) > -1
    ) {
      await this.AnasayfacopyPageInit();
    }
  }
}
